module.exports = "https://ssr-releases-cdn.paperlesspost.com/_next/static/images/tile_professional-05490b49a9e41d9a57a27395ab071b83.jpg";